import SrDialog from "./SrDialog.vue";

SrDialog.install = function(Vue) {
  Vue.component(SrDialog.name, SrDialog);
};

export default SrDialog;


// WEBPACK FOOTER //
// ./packages/SrDialog/index.js